const projects = {
    eyebrow: 'עבודות',
    title: 'דברים שבניתי',
    description: 'פרויקטים עצמאיים מרעיון ועד עלייה לאוויר — החלטות מוצר, סכמה, API וממשק, הכול שלי.',
    selectedTitle: 'עבודות נבחרות',
    selectedDescription: 'כמה פרויקטים שבניתי מקצה לקצה, ממודל הנתונים ועד הממשק החי.',
    viewAll: 'כל הפרויקטים',
};

export default projects;
